module.exports = __webpack_public_path__ + "static/img/searchlist-banner.5f5e37a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/searchlist-banner.jpg
// module id = qUMt
// module chunks = 1